<template>
  <div>
    <el-input
      placeholder="请输入内部锁号,例如：2-222222"
      v-model="form.chaxun"
      class="input-with-select"
    >
      <el-button slot="append" icon="el-icon-search" @click="GetForm()"
        >查询</el-button
      >
    </el-input>
    <el-table :data="tableData" style="width: 100%" v-if="codemeter">
      <el-table-column label="入库日期">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.lock.purchaseDate"
            :disabled="kexing"
            clearable
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="加密锁合同编号">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.lock.contractNo"
            :disabled="kexing"
            clearable
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="外部锁号">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.lock.encryptNo"
            :disabled="kexing"
            clearable
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="内部锁号">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.lock.innerEncryptNo"
            :disabled="kexing"
            clearable
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-select v-model="scope.row.value" :disabled="kexing">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="备注">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.lock.remark"
            :disabled="kexing"
            clearable
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="350px">
        <template slot-scope="scope">
          <el-button size="mini" @click="hetong(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="hetongDelete(scope.$index, scope.row)"
            >删除</el-button
          >
          <el-button
            size="mini"
            @click="shangchuansuo(scope.$index, scope.row)"
            v-if="shangchuan"
            type="success"
            >确认修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-table :data="trial" style="width: 100%" v-if="shiyong">
      <el-table-column label="设置日期" prop="createTime"></el-table-column>
      <el-table-column label="单位名称" prop="companyName"></el-table-column>
      <el-table-column label="内部锁号" prop="innerEncryptNo"></el-table-column>
      <el-table-column label="试用产品详情" prop="productStr" width="680px">
        <template slot-scope="scope" v-if="shiyong">
          <el-table :data="scope.row.product">
            <el-table-column
              label="产品名称"
              prop="moduleName"
              width="200px"
            ></el-table-column>
            <el-table-column
              label="天/时间"
              prop="expiryDate"
            ></el-table-column>
            <el-table-column label="次数" prop="number"></el-table-column>
            <el-table-column label="节点" prop="node"></el-table-column>
          </el-table>
        </template>
      </el-table-column>
    </el-table>
    <el-table :data="formal" v-if="zhengshi">
      <el-table-column
        label="设置日期"
        prop="updateTime"
        width="160px"
      ></el-table-column>
      <el-table-column
        label="单位名称"
        prop="companyName"
        width="140px"
      ></el-table-column>
      <el-table-column
        label="合同编号"
        prop="contractNo"
        width="140px"
      ></el-table-column>
      <el-table-column
        label="外部锁号"
        prop="encryptNo"
        width="100px"
      ></el-table-column>
      <el-table-column
        label="内部锁号"
        prop="innerEncryptNo"
        width="100px"
      ></el-table-column>
      <el-table-column label="正式产品详情">
        <template v-slot="scope">
          <el-table :data="scope.row.products">
            <el-table-column
              prop="name"
              label="产品名称"
              width="120px"
            ></el-table-column>
            <el-table-column label="模块详情">
              <template slot-scope="scopee">
                <el-table :data="scopee.row.modules">
                  <el-table-column
                    prop="moduleName"
                    label="模块名称"
                  ></el-table-column>
                  <el-table-column prop="value" label="永久/租赁">
                    <template slot-scope="scopeee">
                      <el-switch
                        v-model="scopeee.row.value"
                        active-text="租赁"
                        inactive-text="永久"
                      ></el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="startTime"
                    label="起始日期"
                  ></el-table-column>
                  <el-table-column
                    prop="endTime"
                    label="结束日期"
                  ></el-table-column>
                  <el-table-column
                    prop="expiryDate"
                    label="天/时间"
                    width="100px"
                  ></el-table-column>
                  <el-table-column
                    prop="node"
                    label="节点"
                    width="40px"
                  ></el-table-column>
                </el-table>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      codemeter: false,
      tianjia: false,
      shiyong: false,
      zhengshi: false,
      shangchuan: false,
      kexing: true,
      jiamisuoxinxi: false,
      input: {
        encryptNo: "",
        innerEncryptNo: "",
      },
      form: {
        chaxun: "",
      },
      tableData: [],
      options: [],
      trial: [],
      formal: [],
    };
  },
  methods: {
    GetForm() {
      if (this.form.chaxun.length <= 0) {
        return this.$message({
          showClose: true,
          message: "请输入正确的内部锁号",
          type: "error",
        });
      }
      let formData = new FormData();
      formData.append("innerEncryptNo", this.form.chaxun);
      this.$http
        .post(this.$getaxiosurl("/enc/purchase/queryPurchaseLock"), formData)
        .then((response) => {
          if (response.data.lock != null) {
            console.log(response.data);
            this.tableData = [];
            this.zhengshi = false;
            this.shiyong = false;
            this.codemeter = true;
            this.trial = [];
            this.formal = [];
            this.jiamisuoxinxi = false;
            this.kexing = true;
            this.tianjia = false;
            this.shangchuan = false;
            this.tableData.push(response.data);
            for (var i = 0; i < response.data.type.length; i++) {
              this.$set(this.options, i, response.data.type[i]);
            }
            this.$set(this.tableData[0], "value", response.data.lock.status);
            if (response.data.trial.length != 0 && response.data.formal != 0) {
              this.shiyong = true;
              this.zhengshi = true;
              response.data.trial.map((array) => {
                if (array.succ == 1) {
                  this.trial.push(array);
                }
              });
              response.data.formal.map((array) => {
                if (array.succ == 1) {
                  this.formal.push(array);
                }
              });
            } else {
              if (response.data.trial.length != 0) {
                this.shiyong = true;
                this.zhengshi = false;
                response.data.trial.map((succ) => {
                  if (succ.succ == 1) {
                    this.trial.push(succ);
                  }
                });
              }
              if (response.data.formal.length != 0) {
                this.zhengshi = true;
                this.shiyong = false;
                response.data.formal.map((array) => {
                  if (array.succ == 1) {
                    this.formal.push(array);
                  }
                });
              }
            }
            if (response.data.code == "00100") {
              this.$message({
                message: "查询成功",
                type: "success",
                duration: 8000,
              });
            }
          } else {
            this.$message({
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
    hetong() {
      this.kexing = false;
      this.tianjia = true;
      this.shangchuan = true;
    },
    shangchuansuo(index, row) {
      this.kexing = true;
      if (row.lock.encryptNo == "") {
        return this.$message({
          message: "外部锁号不能为空",
          type: "error",
          duration: 8000,
        });
      }
      if (row.lock.innerEncryptNo == "") {
        return this.$message({
          message: "内部锁号不能为空",
          type: "error",
          duration: 8000,
        });
      }
      if (row.value == "") {
        return this.$message({
          message: "状态不能为空",
          type: "error",
          duration: 8000,
        });
      }
      if (row.value == "库存") {
        row.value = "0";
      }
      let formData = new FormData();
      formData.append("id", row.lock.id);
      formData.append("encryptNo", row.lock.encryptNo);
      formData.append("innerEncryptNo", row.lock.innerEncryptNo);
      formData.append("status", row.value);
      formData.append("remark", this.tableData[0].remark);
      this.$http
        .post(this.$getaxiosurl("/enc/purchase/editPurchaseLock"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              message: "修改成功",
              type: "success",
              duration: 8000,
            });
            this.tableData = [];
            this.shiyong = false;
            this.zhengshi = false;
          } else {
            this.$message({
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
    hetongDelete(index) {
      this.tableData.splice(index, 1);
    },
  },
};
</script>
<style scoped>
</style>
